import mdcCard from './mdc-card.vue'
import mdcCardIcon from './mdc-card-icon.vue'
import mdcCardButton from './mdc-card-button.vue'
export const mdcCardComponents = {
  mdcCard,
  mdcCardButton,
  mdcCardIcon,
}